//#region IMPORT
import React, { useState } from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import Commons from '../../../../Services/Common/Common';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSearchText,
  setStartDate,
  setEndDate,
  setYear,
  setCustCd,
} from '../../../../Reducer/SearchReducer';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import SUB_BASIC_01F from '../SUB_BASIC_01/SUB_BASIC_01F';
import SUB_BASIC_02F from '../SUB_BASIC_02/SUB_BASIC_02F';
import SUB_BASIC_03F from '../SUB_BASIC_03/SUB_BASIC_03F';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0, // ✅ flex container 하에서 overflow 계산 가능하게 함
          }}
        >
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function SUB_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  // SearchReducer에 없는 필드들은 로컬 state로 관리
  const [startYear, setStartYear] = useState(
    dayjs().subtract(1, 'year').format('YYYY')
  );
  const [endYear, setEndYear] = useState(dayjs().format('YYYY'));
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="SubcontractorManagement"
          searchYn="Y"
          applyClick={() => props.setListClick3(true)}
          addYn={props.value === 0 || props.value === 1 ? 'N' : 'Y'}
          saveYn={props.value === 1 ? 'N' : 'Y'}
          deleteYn={props.value === 0 ? 'N' : 'Y'}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            } else if (props.value === 2) {
              props.setFilterClick3(true);
            } else if (props.value === 3) {
              props.setFilterClick4(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            } else if (props.value === 2) {
              props.setSaveClick3(true);
            } else if (props.value === 3) {
              props.setSaveClick4(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            } else if (props.value === 2) {
              props.setPrintClick3(true);
            } else if (props.value === 3) {
              props.setPrintClick4(true);
            }
          }}
          conditions={
            props.value === 2
              ? [
                  {
                    type: 'datePicker',
                    views: ['year'],
                    openTo: 'year',
                    title:
                      props.lanList.length === 0
                        ? ''
                        : props.lanList.find(
                            (f) =>
                              f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                          ).LAN_NM, //기간
                    name: Commons.IsMobile() ? searchInfo.year : '조회연도', //기간
                    value: searchInfo.year ? dayjs(searchInfo.year) : dayjs(),
                    onChange: (date) => {
                      let changeYear = dayjs(date).format('YYYY');
                      if (date) {
                        // 시간을 제거하고 "yyyy-MM-dd" 형식으로 변환하여 저장
                        dispatch(setYear(changeYear));
                        props.setSearchClick3(true);
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY',
                  },
                  {
                    type: 'datePicker',
                    title:
                      props.lanList.length === 0
                        ? ''
                        : props.lanList.find(
                            (f) =>
                              f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                          ).LAN_NM, //기간
                    name: Commons.IsMobile()
                      ? searchInfo.startDate
                      : '시작일자',
                    value: searchInfo.startDate
                      ? dayjs(searchInfo.startDate)
                      : dayjs(),
                    onChange: (date) => {
                      if (date) {
                        dispatch(
                          setStartDate(dayjs(date).format('YYYY-MM-DD'))
                        );
                        props.setSearchClick3(true);
                      }
                    },
                    currentLocale: 'ko',
                  },
                  {
                    type: 'datePicker',
                    title:
                      props.lanList.length === 0
                        ? ''
                        : props.lanList.find(
                            (f) =>
                              f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                          ).LAN_NM, //기간
                    name: Commons.IsMobile() ? searchInfo.endDate : '종료일자',
                    value: searchInfo.endDate
                      ? dayjs(searchInfo.endDate)
                      : dayjs(),
                    onChange: (date) => {
                      if (date) {
                        dispatch(setEndDate(dayjs(date).format('YYYY-MM-DD')));
                        props.setSearchClick3(true);
                      }
                    },
                    currentLocale: 'ko',
                  },
                  // ADMIN이면 추가 combo
                  ...(props.userInfo.authCd === 'ADMIN'
                    ? [
                        {
                          type: 'combo',
                          name: '회사',
                          items: searchInfo.coList,
                          value: searchInfo.coCd,
                          onChange: (e) => {
                            props.handleCoChange(e);
                            props.setSearchClick3(true);
                          },
                        },
                      ]
                    : []),
                  {
                    type: 'combo',
                    name: '사업장',
                    items: searchInfo.custList,
                    value: searchInfo.custCd,
                    onChange: (e) => {
                      dispatch(setCustCd(e));
                      props.setSearchClick3(true);
                    },
                  },
                ]
              : props.value === 1
                ? [
                    // 평가 결과 탭 (value === 1) - 시작연도, 종료연도 추가
                    {
                      type: 'datePicker',
                      views: ['year'],
                      openTo: 'year',
                      title:
                        props.lanList.length === 0
                          ? ''
                          : props.lanList.find(
                              (f) =>
                                f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                            ).LAN_NM, //기간
                      name: Commons.IsMobile() ? startYear : '시작연도',
                      value: startYear
                        ? dayjs(startYear, 'YYYY')
                        : endYear
                          ? dayjs(endYear, 'YYYY').subtract(1, 'year')
                          : dayjs().subtract(1, 'year'),
                      onChange: (date) => {
                        let changeYear = dayjs(date).format('YYYY');
                        if (date) {
                          setStartYear(changeYear);
                          props.setSearchClick2(true);
                        }
                      },
                      currentLocale: 'ko',
                      format: 'YYYY',
                    },
                    {
                      type: 'datePicker',
                      views: ['year'],
                      openTo: 'year',
                      title:
                        props.lanList.length === 0
                          ? ''
                          : props.lanList.find(
                              (f) =>
                                f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                            ).LAN_NM, //기간
                      name: Commons.IsMobile() ? endYear : '종료연도',
                      value: endYear ? dayjs(endYear, 'YYYY') : dayjs(),
                      onChange: (date) => {
                        let changeYear = dayjs(date).format('YYYY');
                        if (date) {
                          setEndYear(changeYear);
                          // 종료연도 변경 시 시작연도를 종료연도 -1년으로 자동 설정
                          const newStartYear = dayjs(date)
                            .subtract(1, 'year')
                            .format('YYYY');
                          setStartYear(newStartYear);
                          props.setSearchClick2(true);
                        }
                      },
                      currentLocale: 'ko',
                      format: 'YYYY',
                    },
                    // ADMIN이면 추가 combo
                    ...(props.userInfo.authCd === 'ADMIN'
                      ? [
                          {
                            type: 'combo',
                            name: '회사',
                            items: searchInfo?.coList || [],
                            value: searchInfo?.coCd || '',
                            onChange: (e) => {
                              props.handleCoChange(e);
                              props.setSearchClick2(true);
                            },
                          },
                        ]
                      : []),
                    {
                      type: 'combo',
                      name: '사업장',
                      items: searchInfo?.custList || [],
                      value: searchInfo?.custCd || '',
                      onChange: (e) => {
                        dispatch(setCustCd(e));
                        props.setSearchClick2(true);
                      },
                    },
                  ]
                : [
                    // 수급업체 탭 (value === 0) - 기존 로직 유지
                    // ADMIN이면 추가 combo
                    ...(props.userInfo.authCd === 'ADMIN'
                      ? [
                          {
                            type: 'combo',
                            name: '회사',
                            items: searchInfo?.coList || [],
                            value: searchInfo?.coCd || '',
                            onChange: (e) => {
                              props.handleCoChange(e);
                              props.setSearchClick1(true);
                            },
                          },
                        ]
                      : []),
                    {
                      type: 'combo',
                      name: '사업장',
                      items: searchInfo?.custList || [],
                      value: searchInfo?.custCd || '',
                      onChange: (e) => {
                        dispatch(setCustCd(e));
                        props.setSearchClick1(true);
                      },
                    },
                  ]
          }
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="수급업체"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="평가 결과"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="도급사업 안전보건 협의체 회의록"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <SUB_BASIC_01F
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  listClick1={props.listClick1}
                  setListClick1={props.setListClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <SUB_BASIC_02F
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  listClick2={props.listClick2}
                  setListClick2={props.setListClick2}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={2}>
                <SUB_BASIC_03F
                  year={searchInfo.year}
                  monthDate={props.monthDate}
                  branchVal={props.branchVal}
                  filterClick3={props.filterClick3}
                  setFilterClick3={props.setFilterClick3}
                  searchClick3={props.searchClick3}
                  setSearchClick3={props.setSearchClick3}
                  addClick3={props.addClick3}
                  setAddClick3={props.setAddClick3}
                  saveClick3={props.saveClick3}
                  setSaveClick3={props.setSaveClick3}
                  deleteClick3={props.deleteClick3}
                  setDeleteClick3={props.setDeleteClick3}
                  printClick3={props.printClick3}
                  setPrintClick3={props.setPrintClick3}
                  listClick3={props.listClick3}
                  setListClick3={props.setListClick3}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default SUB_BASIC;
